module.exports = __webpack_public_path__ + "static/img/img_4.53145f58.jpg";